var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIconDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.295 14.295L21 15L16 20L11 15L11.705 14.295L15.5 18.085V9H16.5V18.085L20.295 14.295ZM21 22V20H22V22C22 22.2652 21.8946 22.5196 21.7071 22.7071C21.5196 22.8946 21.2652 23 21 23H11C10.7348 23 10.4804 22.8946 10.2929 22.7071C10.1054 22.5196 10 22.2652 10 22V20H11V22H21Z",
    fill: "#878B97"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    stroke: "#878B97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconDisabled);
export default __webpack_public_path__ + "static/media/downloadIconDisabled.3f59fe0bc3eff1f7f7ec37f64e8a707d.svg";
export { ForwardRef as ReactComponent };